import { useQuery } from '@tanstack/react-query';
import { fetchStats } from '../services/api';

export default function Dashboard() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['stats'],
    queryFn: fetchStats,
  });

  if (isLoading) {
    return <div className="text-center py-12">Loading...</div>;
  }

  return (
    <div className="px-4 py-6 sm:px-0">
      <h2 className="text-2xl font-semibold text-gray-900 mb-6">Dashboard</h2>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Total Questions
            </dt>
            <dd className="mt-1 text-3xl font-semibold text-gray-900">
              {stats?.totalQuestions || 0}
            </dd>
          </div>
        </div>

        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Answered
            </dt>
            <dd className="mt-1 text-3xl font-semibold text-gray-900">
              {stats?.answeredQuestions || 0}
            </dd>
          </div>
        </div>

        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Avg Response Time
            </dt>
            <dd className="mt-1 text-3xl font-semibold text-gray-900">
              {stats?.avgResponseTime || 0}s
            </dd>
          </div>
        </div>

        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Conversion Rate
            </dt>
            <dd className="mt-1 text-3xl font-semibold text-gray-900">
              {stats?.conversionRate || 0}%
            </dd>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Recent Questions
          </h3>
          <div className="space-y-4">
            {stats?.recentQuestions?.map((q: any, i: number) => (
              <div key={i} className="border-l-4 border-blue-500 pl-4">
                <p className="text-sm text-gray-900">{q.question}</p>
                <p className="text-xs text-gray-500 mt-1">
                  {new Date(q.createdAt).toLocaleString()}
                </p>
              </div>
            )) || <p className="text-gray-500">No recent questions</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
